import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14f7feaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "afvalwijzer" }
const _hoisted_2 = {
  key: 0,
  class: "afvalwijzer-button__wrapper"
}
const _hoisted_3 = {
  key: 1,
  class: "afvalwijzer-afvalstroom__wrapper"
}
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "afvalwijzer__options" }
const _hoisted_6 = { class: "zipcode afvalwijzer__option" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "zipcode" }, "Postcode", -1))
const _hoisted_8 = { class: "house_number afvalwijzer__option" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "house_number" }, "House number", -1))

import { onMounted, reactive, Ref, ref } from "vue";
import Cookies from "js-cookie";

interface GetAddressResponse {
  0: {
    bagid: string;
    postcode: string;
    huisnummer: number;
    huisletter: string;
    toevoeging: string;
    description: string;
    straat: string;
    woonplaats: string;
    woonplaatsId: number;
    gemeenteId: number;
    latitude: number;
    longitude: number;
  };
}

interface GetAfvalstromenResponse {
  id: number;
  parent_id: number;
  title: string;
  tags: string;
  page_title: string;
  content: string;
  menu_title: string;
  icon: string;
  icon_data: string;
  ophaaldatum: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'pAfvalwijzer',
  setup(__props) {

const permission: Ref<string> = ref(Notification.permission);
const addressId: Ref<string | null> = ref(null);
const afvalstromen: Ref<Array<GetAfvalstromenResponse>> = ref([]);
const options = reactive({
  address: {
    zipcode: null,
    houseNumber: null,
  },
});

async function grantNotifications() {
  await Notification.requestPermission();
  permission.value = Notification.permission;
}

onMounted(async () => {
  addressId.value = Cookies.get("addressId") ?? null;
  await updateAfvalstromen();
  await setNotifications();
});

async function updateAfvalstromen() {
  if (!addressId.value) {
    const addressResponse = await getAddress();
    const addressJson: GetAddressResponse = await addressResponse.json();
    addressId.value = addressJson?.[0]?.bagid ?? null;
  }
  if (addressId.value) {
    Cookies.set("addressId", addressId.value);
    const afvalstromenResponse = await getAfvalstromen();
    afvalstromenResponse
      .json()
      .then((response: Array<GetAfvalstromenResponse>) => {
        afvalstromen.value = response.filter((f) => f.ophaaldatum);
      });
  }
}

async function getAddress() {
  return fetch(
    `https://afvalkalender.sudwestfryslan.nl/adressen/${options.address.zipcode}:${options.address.houseNumber}`,
    {
      method: "GET",
    }
  );
}

async function getAfvalstromen() {
  return fetch(
    `https://afvalkalender.sudwestfryslan.nl/rest/adressen/${addressId.value}/afvalstromen`,
    {
      method: "GET",
    }
  );
}

async function setNotifications() {
  const serviceWorker = await navigator.serviceWorker.ready;
  const options = {
    userVisibleOnly: true,
    applicationServerKey: "offalkalinder",
  };
  // serviceWorker.pushManager.subscribe(options).then(function (subscription) {
  //   // sendSubscriptionToServer function is implemented in Code Snippet 13
  //   // return sendSubscriptionToServer(subscription);
  // });
}

function getDiffInDaysLabel(date: string) {
  let ophaaldatum = new Date(date);
  let now = new Date();

  let Difference_In_Time = now.getTime() - ophaaldatum.getTime();
  const diffInDays = Math.abs(
    Math.round(Difference_In_Time / (1000 * 3600 * 24))
  );
  let dayLabel = "morgen";

  switch (diffInDays) {
    case 0:
      dayLabel = "Vandaag";
      break;
    case 1:
      dayLabel = "Morgen";
      break;
  }

  return (
    Array.from(Array(diffInDays > 3 ? diffInDays - 2 : 0))
      .map((day, index) => (index === 0 ? "Over" : "over"))
      .join("") + dayLabel
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (permission.value !== 'granted')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", {
            onClick: grantNotifications,
            textContent: `Allow notifications`
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(afvalstromen.value, (afvalstroom) => {
            return (_openBlock(), _createElementBlock("p", {
              key: afvalstroom.id,
              textContent: _toDisplayString(
          `${afvalstroom.title}: ${new Date(
            afvalstroom.ophaaldatum
          ).toLocaleDateString()} (${getDiffInDaysLabel(
            afvalstroom.ophaaldatum
          )})`
        )
            }, null, 8, _hoisted_4))
          }), 128))
        ])),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          id: "zipcode",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((options.address.zipcode) = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, options.address.zipcode]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("input", {
          id: "house_number",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((options.address.houseNumber) = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, options.address.houseNumber]
        ])
      ]),
      _createElementVNode("button", { onClick: updateAfvalstromen }, "Update")
    ])
  ]))
}
}

})